// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__Ioz-Y","header":"MergedInvoice_header__JKtGV"};